module.exports = __webpack_public_path__ + "img/churrasco.df070c96.png";